module.exports = __webpack_public_path__ + "img/ewnn.d6208972.jpg";